import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProtectAPi } from '../../../api/ProtectAPi';
import BackButton from '../../tools/BackButton';
import swal from 'sweetalert';

const UserCreate = () => {
  const navigate = useNavigate();
  const { http } = ProtectAPi();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [roles, setRoles] = useState('');
  const [password, setPassword] = useState('');
  const [password_confirmation, setPassword_confirmation] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const [loader, setLoader] = useState('off');

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [statusError, setStatusError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [password_confirmationError, setPassword_confirmationError] = useState('');
  const [rolesError, setRolesError] = useState('');

  const [allroles, setAllRoles] = useState([]);

  useEffect(() => {
    http.get('/get-all-roles')
      .then(res => setAllRoles(res.data))
      .catch(error => console.error('Error fetching roles:', error));
  }, []);

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);
    const previewURL = URL.createObjectURL(selectedImage);
    setImagePreview(previewURL);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordConfirmationVisibility = () => {
    setShowPasswordConfirmation(!showPasswordConfirmation);
  };

  const submitForm = () => {
    setLoader('on');

    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('image', image);
    formData.append('status', status);
    formData.append('password', password);
    formData.append('password_confirmation', password_confirmation);
    formData.append('roles', roles);

    http.post('/add-user', formData)
      .then(res => {
        if (res.data.status === '422') {
          setLoader('off');
          const errors = res.data.error;
          setNameError(errors.name ?? '');
          setEmailError(errors.email ?? '');
          setStatusError(errors.status ?? '');
          setPasswordError(errors.password ?? '');
          setPassword_confirmationError(errors.password_confirmation ?? '');
          setRolesError(errors.roles ?? '');
        } else {
          navigate('/admin/users-list');
          swal('Success', res.data.msg, 'success');
        }
      }).catch(error => console.error('Error:', error));
  };

  return (
    <div className="main-content">
      <section className="section userr">
        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card card-primary">
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-3">
                    <h5>Create New User</h5>
                    <BackButton />
                  </div>

                  <div className="row align-items-start">
                    {/* Image Upload */}
                    <div className="col-md-3">
                      <label htmlFor="userImage" className="w-100 text-center">
                        <div className="image-box border dottet p-2 rounded mb-2"
                          >
                          {imagePreview ? (
                            <img src={imagePreview} className="img-fluid w-100 h-100" style={{ objectFit: 'cover' }} alt="Preview" />
                          ) : (
                            <img src="https://www.shareicon.net/data/512x512/2016/05/24/770137_man_512x512.png"
                              className="img-fluid w-100 h-100"
                              style={{ objectFit: 'contain' }}
                              alt="Default" />
                          )}
                        </div>
                        <input type="file" id="userImage" className="form-control d-none" onChange={handleImageChange} />
                        <span className="btn btn-primary w-100">Upload Image</span>
                      </label>
                    </div>

                    {/* Input Fields */}
                    <div className="col-md-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label>Name</label>
                            <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                            <span className="text-danger">{nameError}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label>Email</label>
                            <input type="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} />
                            <span className="text-danger">{emailError}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label>Status</label>
                            <select className="form-control" value={status} onChange={e => setStatus(e.target.value)}>
                              <option value="">Select</option>
                              <option value="1">Active</option>
                              <option value="2">De-Active</option>
                            </select>
                            <span className="text-danger">{statusError}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label>Role</label>
                            <select className="form-control" value={roles} onChange={e => setRoles(e.target.value)}>
                              <option value="" disabled>Select Role</option>
                              {allroles.map((role, index) => (
                                <option key={index} value={role.name}>{role.name}</option>
                              ))}
                            </select>
                            <span className="text-danger">{rolesError}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label>Password</label>
                            <div className="input-group">
                              <input
                                type={showPassword ? 'text' : 'password'}
                                className="form-control"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                              />
                              <div className="input-group-append">
                                <button type="button" className="btn btn-outline-secondary" onClick={togglePasswordVisibility}>
                                  <i className="fa fa-eye"></i>
                                </button>
                              </div>
                            </div>
                            <span className="text-danger">{passwordError}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label>Confirm Password</label>
                            <div className="input-group">
                              <input
                                type={showPasswordConfirmation ? 'text' : 'password'}
                                className="form-control"
                                value={password_confirmation}
                                onChange={e => setPassword_confirmation(e.target.value)}
                              />
                              <div className="input-group-append">
                                <button type="button" className="btn btn-outline-secondary" onClick={togglePasswordConfirmationVisibility}>
                                  <i className="fa fa-eye"></i>
                                </button>
                              </div>
                            </div>
                            <span className="text-danger">{password_confirmationError}</span>
                          </div>
                        </div>

                      </div>
                    </div>

                  {/* Submit Button */}
                  <div className="col-md-12 text-center mt-4 mb-4">
                    {loader === 'off' ? (
                      <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Create User </button>
                    ) : (
                      <div className="spinner-border text-dark" role="status"></div>
                    )}
                  </div>


                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UserCreate;
